import {
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { BaseRoute } from "@core/routing/helper-components/Routes";

interface NavItemProps {
  route: BaseRoute;
  isOpen: boolean;
  isActive: boolean;
  onClick: () => void;
}

export const NavItem = ({ route, isOpen, isActive, onClick }: NavItemProps) => {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate(route.path);
    onClick();
  };

  return (
    <ListItem disablePadding>
      <ListItemButton
        onClick={handleClick}
        sx={{
          minHeight: 48,
          justifyContent: isOpen ? "initial" : "center",
          px: 2.5,
          "& .MuiListItemIcon-root": {
            color: isActive ? "primary.main" : "inherit",
          },
          "& .MuiListItemText-primary": {
            color: isActive ? "primary.main" : "inherit",
            fontWeight: isActive ? 600 : 400,
          },
          "&:hover": {
            backgroundColor: "rgba(25, 118, 210, 0.12)",
            "& .MuiListItemIcon-root": {
              color: "primary.main",
            },
            "& .MuiListItemText-primary": {
              color: "primary.main",
            },
          },
        }}
      >
        <ListItemIcon
          sx={{
            minWidth: 0,
            mr: isOpen ? 3 : "auto",
            justifyContent: "center",
          }}
        >
          {route.icon}
        </ListItemIcon>
        <ListItemText
          primary={route.sidebarText || route.title}
          sx={(theme) => ({
            opacity: isOpen ? 1 : 0,
            maxWidth: isOpen ? 240 : 0,
            overflow: "hidden",
            whiteSpace: "nowrap",
            display: "block",
            transition: theme.transitions.create(["opacity", "max-width"], {
              duration: 200,
              easing: theme.transitions.easing.easeInOut,
            }),
          })}
        />
      </ListItemButton>
    </ListItem>
  );
};
